var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "elevation-12",
      staticStyle: {
        width: "330px",
        position: "fixed",
        right: "0",
        "z-index": "15",
        "max-height": "calc(100% - 65px)",
        "overflow-y": "auto",
        "overflow-x": "hidden"
      }
    },
    [
      _c(
        "v-expansion-panels",
        [
          _c(
            "v-expansion-panel",
            { key: 0, attrs: { "expand-icon": "fa-arrow-alt-circle-down" } },
            [
              _c("v-expansion-panel-header", [
                _c("div", [
                  _c("h2", { staticStyle: { "margin-right": "15px" } }, [
                    _c("span", { staticClass: "ml-2 hidden-xs-only" }, [
                      _vm._v(
                        _vm._s(_vm.$t("templateList.documentTemplates")) +
                          " (" +
                          _vm._s(_vm.templateList.length) +
                          ")"
                      )
                    ]),
                    _c("span", { staticClass: "ml-2 hidden-sm-and-up" }, [
                      _vm._v(_vm._s(_vm.$t("templateList.documentTemplates")))
                    ])
                  ])
                ])
              ]),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "div",
                    {
                      staticClass: "pb-3",
                      staticStyle: { "max-height": "450px" }
                    },
                    [
                      _vm.templateList.length === 0
                        ? _c("div", [
                            _vm._v(" " + _vm._s(_vm.$t("global.noData")) + " ")
                          ])
                        : _vm._e(),
                      _vm._l(_vm.templateList, function(template) {
                        return _c(
                          "div",
                          { key: template.id, staticClass: "text-no-wrap" },
                          [
                            _c(
                              "v-row",
                              { staticClass: "ma-0" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "", "z-index": "500" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  {
                                                    staticClass: "pt-3",
                                                    staticStyle: {
                                                      "max-width": "152px"
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(template.name) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.createdAt")) +
                                        " " +
                                        _vm._s(template.createdAt) +
                                        " " +
                                        _vm._s(_vm.$t("global.by")) +
                                        " " +
                                        _vm._s(template.createdByName) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("v-spacer"),
                                _c(
                                  "div",
                                  { staticClass: "py-2" },
                                  [
                                    template.owner
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              "z-index": "500"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mx-0",
                                                            attrs: {
                                                              icon: "",
                                                              small: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.remove(
                                                                  template
                                                                )
                                                              }
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "fa-minus-circle"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("global.delete")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    template.owner
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              "z-index": "500"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mx-0",
                                                            attrs: {
                                                              disabled:
                                                                _vm.$store
                                                                  .getters[
                                                                  "Ajax/loading"
                                                                ],
                                                              icon: "",
                                                              small: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openSaveDialog(
                                                                  template
                                                                )
                                                              }
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("fa-save")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("global.save")) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "", "z-index": "500" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _vm.canViewLoadButton
                                                    ? _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mx-0",
                                                            attrs: {
                                                              icon: "",
                                                              small: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.load(
                                                                  template
                                                                )
                                                              }
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "fa-file-download"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "templateList.loadTemplate"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("v-divider", { staticClass: "mb-1" })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      staticStyle: { width: "285px" },
                      attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
                      on: {
                        click: function($event) {
                          return _vm.openSaveDialog(null)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("templateList.newTemplateButton")))]
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "290", persistent: "" },
                      model: {
                        value: _vm.dialog,
                        callback: function($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", { staticClass: "headline" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dialogValues.id == null
                                    ? _vm.$t(
                                        "templateList.newTemplateDialog.title"
                                      )
                                    : _vm.$t(
                                        "templateList.newTemplateDialog.titleEdit"
                                      )
                                ) +
                                " "
                            )
                          ]),
                          _c(
                            "v-card-text",
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "templateList.newTemplateDialog.content"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "templateList.newTemplateDialog.name"
                                  )
                                },
                                model: {
                                  value: _vm.dialogValues.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dialogValues, "name", $$v)
                                  },
                                  expression: "dialogValues.name"
                                }
                              }),
                              _c("v-checkbox", {
                                attrs: { label: _vm.$t("global.public") },
                                model: {
                                  value: _vm.dialogValues.public,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dialogValues, "public", $$v)
                                  },
                                  expression: "dialogValues.public"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1", text: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.dialog = false
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.$store.getters["Ajax/loading"],
                                    color: "blue darken-1",
                                    text: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.save()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("global.save")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }